import { useAppSelector } from 'redux/hooks';

const useUser = () => {
  const user = useAppSelector(s => s.auth.user);
  return user;
};

export default useUser;
